import React from 'react';
import { 
    Filter,
    List, 
    Datagrid,
    TextField, 
    TextInput,
    SearchInput,
    EditButton,
    ShowButton
} from 'react-admin';
import BoolNumField from '../controls/BoolNumField'

const quickFilterStyles = {
    root: {
        marginBottom: '0.7em',
    },
};


export const EquipmentFilters = props => (
    <Filter {...props}>
        <SearchInput source="serial_num" alwaysOn  placeholder='Serial Number'/>
        <TextInput source="manufacturer" lable="Manufacture" />
        <TextInput source="name" lable="Type" />        
    </Filter>
);

export const EquipmentList = props => (
    <List 
        {...props}
        filters={<EquipmentFilters />}
        perPage={20}
        sort={{ field: 'name', order: 'ASC' }}
        bulkActionButtons ={false}
        title= "Equipment list"
        >
        <Datagrid    >               
            <TextField source="name" label="Type" />
            <TextField source="equip_id" label="Equipment ID" />  
            <TextField source="manufacturer" lablel="Manufacturer"/>
            <TextField source="serial_num" lablel="Serial#"  />
            <BoolNumField  source="status" label="Is Active?" />
            <ShowButton />
            <EditButton />
           </Datagrid>
    </List>
);


export default EquipmentList